<template>
    <div class="o-wrapper">
        <div class="o-grid" :class="cards.length === 0 ? 'o-grid--center' : ''">
            <div v-if="cards.length !== 0 || showPlaceholders" class="o-grid__item u-width-full">
                <div id="cardsWrapper" class="cards__wrapper">
                    <div class="cards" id="cards">
                        <content-placeholders v-if="showPlaceholders"></content-placeholders>
                        <post-card-api
                            v-for="card in cards"
                            :key="card.id"
                            :card="card"
                        ></post-card-api>
                    </div>
                </div>
            </div>
            <div v-else class="o-grid__item u-width-8/12 u-width-full@l" v-if="showEmptyMessage">
                <div v-if="$root.user.username === $root.profile.username" class="c-empty-state">
                    <h4>Ready to add your first piece of {{$root.community.title}} content?</h4>
                    <p>Contributing to the communities you are a member of is one of the most valuable roles of a {{ $root.brand.name }} user, to get started simply click on the Add Content icon below.</p>
                </div>
                <div v-else class="c-empty-state">
                    <h4>{{noContentMessage}}</h4>
                    <p>As soon as they do it will be listed here like the example post below.</p>
                    <article class="card dc preview empty">
                        <div class="card__inner">
                            <div data-card-type="message" class="card__media">
                                <a href="/">
                                    <img :src="$cdn('/img2.0/example-article.jpg')" alt="example image">
                                </a>
                            </div>
                            <header>
                                <div class="card__logo">
                                    <a :href="'/u/' + $root.profile.username">
                                        <img :src="$cdn('/img/communities/1/main.jpg')" alt="example post" class="logo">
                                        <img :src="$root.profile.avatar" width="24" height="24" class="ugc__avatar" :alt="$root.profile.first_name + ' ' + $root.profile.surname">
                                    </a>
                                </div>
                                <div class="card__comm-name dc">
                                    <div>
                                        <strong>{{ $root.profile.first_name }} {{ $root.profile.surname }}</strong>
                                        posted<br>
                                        in
                                        <strong>
                                            <a href="/">{{ communityName }}</a>
                                        </strong>
                                    </div>
                                    <time>{{ postDate }}</time>
                                </div>
                                <div class="card__menu">
                                    <div class="dots">
                                        <div class="dot"></div>
                                    </div>
                                </div>
                            </header>
                            <p class="title">
                                <strong>{{ $root.profile.first_name }}'s content cards will appear once they have added and published their own unique content in a {{ $root.brand.name }} community.</strong>
                            </p>
                            <div class="card-ctas-wrap">
                                <div class="card-ctas">
                                    <button data-cy="like-post" class="card__likes">
                                        <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>0</span>
                                    </button>
                                </div>
                                <div class="slider-nav"></div>
                            </div>
                            <div class="card__repost">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                                    <path d="M1 4V6C1 9.31371 3.68629 12 7 12H11M21 12V10C21 6.68629 18.3137 4 15 4H11" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M14 1L11 4L14 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 15L12 12L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Repost</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi";
import MasonryStore from "../../configs/masonry-store";
import ContentPlaceholders from "../ContentPlaceholders.vue";

export default {
    components: {
        ContentPlaceholders,
        PostCardApi
    },
    data() {
        return {
            cards: [],
            communityName: this.$root.brand.name,
            createUrl: '/post/create',
            loading: false,
            masonry: MasonryStore,
            next: true,
            page: 1,
            noContentMessage: this.$root.profile.first_name + ' has not yet posted any content to a community',
            showEmptyMessage: false,
            showPlaceholders: false,
            postDate: ''
        }
    },
    created() {
        this.$root.$on('profile-search-posts', (data) => {
            this.fetchData(data);
        });
        this.$root.$on('bus-profile-posts-reset-cache', (data) => {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.ugcposts + '-' + this.$root.profile.user_id;
            localStorage.removeItem(cacheKey);
        });
        this.fetchData();
        if (this.$root.community) {
            this.createUrl += this.$root.community.url ? '/' + this.$root.community.url : '';
            this.noContentMessage = this.$root.profile.first_name + ' has not yet posted any content to the ' + this.$root.community.title + ' community';
            this.communityName = this.$root.community.title;
            console.log('this.$root.community', this.$root.community);
        }
        let today = new Date();
        this.postDate = (today.toLocaleString('default', { month: 'short' })) + ' ' + today.getDate() + ', ' + today.getFullYear();
    },
    updated() {
        this.$nextTick(() => {
            this.masonry.load();
        })
    },
    mounted() {
        window.addEventListener('scroll', this.loadPostsOnScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadPostsOnScroll);
    },
    methods: {
        fetchData(search) {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.ugcposts + '-' + this.$root.profile.user_id;
            if (!search) {
                const cachedPosts = this.$simpleStore.getWithSlidingExpiry(cacheKey);
                if (cachedPosts != null) {
                    this.cards = cachedPosts;
                    if (this.cards.length === 0) {
                        this.showEmptyMessage = true;
                    } else {
                        this.masonry.load();
                    }
                    return;
                }
            } else {
                this.cards = [];
                this.page = 1;
                this.showEmptyMessage = false;
                window.addEventListener('scroll', this.loadPostsOnScroll);
            }
            let postData = {
                page: this.page,
                user_id: this.$root.profile.user_id,
                community_id: this.$root.community.id,
                search: search
            };
            if (this.showEmptyMessage === true) {
                return;
            }
            if (search) {
                this.$root.$emit('bus-profile-search-loading', true);
            }
            this.showPlaceholders = this.page === 1;
            this.loading = true;
            this.$http.post('/api/v1/posts/user', postData).then(response => {
                this.loading = false;
                this.showPlaceholders = false;
                if (search) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                if (this.cards.length === 0 && response.data.cards.length === 0) {
                    this.showEmptyMessage = true;
                    if (!search) {
                        this.$simpleStore.setWithExpiry(cacheKey, []);
                    }
                    return;
                }
                let totalPages = response.data.total_pages;
                if (this.cards.length === 0) {
                    this.cards = response.data.cards;
                } else {
                    this.cards.push.apply(this.cards, response.data.cards);
                }
                if (!search) {
                    this.$simpleStore.setWithExpiry(cacheKey, this.cards);
                }
                this.next = totalPages > this.page;
                this.page++;
                if (this.page > totalPages) {
                    window.removeEventListener('scroll', this.loadPostsOnScroll);
                }
            }, response => {
                if (search) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        loadPostsOnScroll() {
            // only calculate scroll height when not loading and when there are more posts to load
            if (this.loading === false && this.next) {
                let percentageScroll = (Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight;
                // load more posts when scrolled 90% of screen height
                if (percentageScroll > 0.9) {
                    this.fetchData();
                }
            }
        }
    }
}
</script>
